import { render, staticRenderFns } from "./configBibleAdd.vue?vue&type=template&id=87e43a3a&"
import script from "./configBibleAdd.vue?vue&type=script&lang=js&"
export * from "./configBibleAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports